import React from 'react';
import { useSelector } from 'react-redux';
import { method, DATA_STEP, credits, card } from '../../../constants/payData';
import { selectorsLocale } from '../../../redux/locale/localeReducer';
import { buildLocale } from '../../../utils/buildLocale';
import { getLocaleStorageItem } from '../../../utils/localStorageHelper';
import { useFormattingContext } from '../../../context/FormattingContext';
import HeaderLogo from '../../common/HeaderLogo';
import CreditCardComponent from '../../BasketPage/Components/CreditCardComponent';

interface IProps {
  createOrder: () => void;
  draftData: any;
  setPayStep: (value: string) => void;
  resetChecked: () => void;
}

const PaymentStep = (props: IProps) => {
  const { draftData, setPayStep, resetChecked } = props;
  const payType = getLocaleStorageItem(method);
  const currentTranslate = useSelector(selectorsLocale.getTranslate);
  const { formatPrice } = useFormattingContext();

  return (
    <section className="pay-page">
      <header className="pay-page_header">
        <HeaderLogo />
        <span
          className="pay-page_close"
          onClick={() => {
            resetChecked();
            setPayStep(DATA_STEP);
          }}></span>
      </header>
      <div className="container">
        <div className="pay-page_top">
          <h1>{buildLocale(currentTranslate, 'payPagePayment')}</h1>
          <div className="pay-page_top-total">
            <span>{buildLocale(currentTranslate, 'mobileCouponAccepted')}</span>{' '}
            {(draftData.coupon || getLocaleStorageItem(credits)) && (
              <span className="price price-prev">
                {formatPrice(
                  +draftData.productsPrice +
                    (draftData.rackTotalDeposit ? +draftData.rackTotalDeposit : 0) +
                    (draftData.deliveryCost ? draftData.deliveryCost : 0) +
                    (draftData.bottleTotalDeposit ? +draftData.bottleTotalDeposit : 0) +
                    (draftData.totalWeightDeposit ? +draftData.totalWeightDeposit : 0) +
                    (draftData.totalSecurityDeposit ? +draftData.totalSecurityDeposit : 0),
                )}
              </span>
            )}
            <span className="price">{formatPrice(draftData.totalPrice)}</span>
          </div>
        </div>
        <div className="pay-block">
          <div className="pay-block_one pay-block_card">{payType === card && <CreditCardComponent />}</div>
        </div>
      </div>
    </section>
  );
};

export default PaymentStep;
